import { Menu } from '#app/components/Menu/Menu.js';
import { Tag, TagSize, type TagVariant } from '#app/components/Tags/Tag.js';
import { type TagMenuItem } from '../types.js';
import { useCallback } from 'react';
import { css, styled } from 'styled-components';

type OverflowToolsMenuProps = {
  readonly buttonSize: number;
  readonly isOpen: boolean;
  readonly items: TagMenuItem[];
  readonly placement?: 'bottom' | 'left' | 'right' | 'top';
  readonly strategy: 'absolute' | 'fixed';
  readonly tagSize: TagSize;
  readonly toggleMenu: () => void;
  readonly variant: TagVariant;
};

const PanelItemContainer = styled.div`
  ${({ theme }) => css`
    width: fit-content;

    ${theme.mediaQueries.lg} {
      max-width: 300px;
      max-height: 288px;
      overflow-y: auto;
    }
  `}
`;

const MenuItem = styled(Menu.Item)`
  ${({ theme }) => css`
    cursor: default;
    padding: 4px;

    background-color: transparent;
    :hover {
      background-color: transparent;
    }

    ${theme.mediaQueries.lg} {
      padding: 0px;
    }
  `}
`;

const MenuTag = styled(Tag)`
  background-color: transparent;
  :hover {
    background-color: transparent;
  }
`;

export const OverflowMenu = ({
  isOpen,
  items,
  placement,
  strategy,
  tagSize,
  toggleMenu,
  variant,
}: OverflowToolsMenuProps) => {
  const handleOverflowMenuButtonClick = useCallback(() => {
    toggleMenu();
  }, [toggleMenu]);

  return (
    <Menu
      isOpen={isOpen}
      placement={placement}
      strategy={strategy}
      toggleMenu={toggleMenu}
    >
      <Menu.Reference>
        <button
          onClick={(event) => {
            event.stopPropagation();
            handleOverflowMenuButtonClick();
          }}
          type="button"
        >
          <Tag
            label={`+${items.length}`}
            size={tagSize}
            variant={variant}
          />
        </button>
      </Menu.Reference>

      <Menu.Panel>
        <PanelItemContainer>
          {items.map((item) => {
            return (
              <MenuItem key={item.value}>
                <MenuTag
                  href={item.href}
                  icon={item.icon}
                  label={item.label}
                  readOnly={item?.readOnly ?? false}
                  size={tagSize}
                  variant="whiteMobileLarger"
                />
              </MenuItem>
            );
          })}
        </PanelItemContainer>
      </Menu.Panel>
    </Menu>
  );
};
